(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astra-new-arrivals-collection"]) return;
  try {
    
  if (!customElements.get('astra-arrivals-catalog')) {
    customElements.define('astra-arrivals-catalog', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.astra-news-grid');
        this.empty = this.querySelector('.astra-news-empty');
        this.status = this.querySelector('[role="status"]');
        this.next = this.querySelector('[data-next]');
        this.refresh = () => {
          const now = Date.now();
          this.grid.querySelectorAll('[data-expires]').forEach(item => {
            if (Number(item.dataset.expires) * 1000 <= now) item.remove();
          });
          const cards = [...this.grid.children];
          cards.sort((a, b) => Number(b.dataset.expires) - Number(a.dataset.expires)).forEach(item => this.grid.append(item));
          this.empty.hidden = cards.length > 0 || Boolean(this.next && !this.next.hidden);
        };
        this.onNext = event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.loadRemaining();
        };
        this.next?.addEventListener('click', this.onNext);
        this.onVisible = () => { if (!document.hidden) this.refresh(); };
        window.addEventListener('pageshow', this.refresh);
        document.addEventListener('visibilitychange', this.onVisible);
        this.timer = setInterval(this.refresh, 60000);
        this.refresh();
        if (this.next) this.loadRemaining();
      }
      async loadRemaining() {
        if (this.busy || !this.next || this.next.hidden) return;
        this.busy = true;
        this.controller = new AbortController();
        this.status.textContent = this.dataset.loading;
        this.grid.setAttribute('aria-busy', 'true');
        const visited = new Set();
        try {
          while (this.next && !this.next.hidden && this.isConnected) {
            const url = new URL(this.next.href, location.origin);
            url.searchParams.set('section_id', this.dataset.section);
            if (visited.has(url.href)) throw new Error('Pagination repeated');
            visited.add(url.href);
            const response = await fetch(url, { credentials:'same-origin', signal:this.controller.signal });
            if (!response.ok) throw new Error('Page unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const incoming = doc.querySelector('astra-arrivals-catalog');
            if (!incoming) throw new Error('Missing catalog');
            const existing = new Set([...this.grid.children].map(item => item.dataset.newProduct));
            incoming.querySelectorAll('[data-new-product]').forEach(item => {
              if (!existing.has(item.dataset.newProduct)) this.grid.append(item);
            });
            const next = incoming.querySelector('[data-next]');
            if (next) this.next.href = next.getAttribute('href');
            else this.next.hidden = true;
            this.refresh();
          }
          this.status.textContent = '';
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = this.dataset.failed;
        } finally {
          this.busy = false;
          this.grid.removeAttribute('aria-busy');
          this.refresh();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        clearInterval(this.timer);
        window.removeEventListener('pageshow', this.refresh);
        document.removeEventListener('visibilitychange', this.onVisible);
        this.next?.removeEventListener('click', this.onNext);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-product-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('astra-product-cta')) {
    customElements.define('astra-product-cta', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-cta-submit]');
        this.label = this.querySelector('[data-cta-label]');
        this.spinner = this.querySelector('.loading__spinner');
        this.price = this.querySelector('[data-cta-price]');
        this.variant = this.querySelector('[data-cta-variant]');
        this.quantity = this.querySelector('[data-cta-quantity]');
        this.error = this.querySelector('[data-cta-error]');
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        };
        this.attach = () => {
          this.observer?.disconnect();
          this.main?.removeEventListener('input', this.schedule);
          this.main?.removeEventListener('change', this.schedule);
          this.main = document.getElementById(`MainProduct-${this.dataset.mainId}`);
          if (this.main) {
            this.observer = new MutationObserver(this.schedule);
            this.observer.observe(this.main, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','hidden','value']});
            this.main.addEventListener('input', this.schedule);
            this.main.addEventListener('change', this.schedule);
          }
          this.sync();
        };
        this.guard = (event) => {
          this.sync();
          if (this.button.disabled) {
            event.preventDefault();
            return;
          }
          const choice = this.quickChoice;
          if (choice?.activate && choice.dialog?.showModal) {
            event.preventDefault();
            choice.activate(this.button);
          }
        };
        this.button.addEventListener('click', this.guard);
        document.addEventListener('shopify:section:load', this.attach);
        this.attach();
        customElements.whenDefined('astra-quick-choice').then(() => { if (this.isConnected) this.schedule(); });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.main?.removeEventListener('input', this.schedule);
        this.main?.removeEventListener('change', this.schedule);
        this.button?.removeEventListener('click', this.guard);
        document.removeEventListener('shopify:section:load', this.attach);
      }
      get quickChoice() {
        return document.querySelector(`astra-quick-choice[data-section="${CSS.escape(this.dataset.mainId)}"]`);
      }
      sync() {
        const form = this.button.form;
        const source = document.getElementById(`ProductSubmitButton-${this.dataset.mainId}`);
        const loading = source?.classList.contains('loading') || false;
        const choice = this.quickChoice;
        const choose = choice?.activate && choice.dialog?.showModal && choice.dataset.direct !== 'true';
        this.button.disabled = !form || !source || loading || (!choose && (source.disabled || source.getAttribute('aria-disabled') === 'true'));
        this.button.setAttribute('aria-busy', String(loading));
        this.button.classList.toggle('loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);
        if (!source) return;
        const popup = choose ? 'dialog' : source.getAttribute('aria-haspopup');
        if (popup) this.button.setAttribute('aria-haspopup', popup);
        else this.button.removeAttribute('aria-haspopup');
        if (choose) this.button.setAttribute('aria-controls', choice.dialog.id);
        else this.button.removeAttribute('aria-controls');
        const text = choose ? choice.trigger.textContent.trim() : source.querySelector('span:not(.hidden)')?.textContent.trim();
        if (text && this.label.textContent !== text) this.label.textContent = text;
        const price = document.getElementById(`price-${this.dataset.mainId}`);
        if (price && this.price.innerHTML !== price.innerHTML) this.price.innerHTML = price.innerHTML;
        this.price.hidden = !price || price.classList.contains('hidden');
        const quantity = form?.elements.namedItem('quantity')?.value || '1';
        if (this.quantity.textContent !== quantity) this.quantity.textContent = quantity;
        const selected = this.main?.querySelector('variant-selects [data-selected-variant]');
        if (selected) {
          try {
            const variant = JSON.parse(selected.textContent);
            this.variant.hidden = !variant?.title || variant.title === 'Default Title';
            if (this.variant.textContent !== (variant?.title || '')) this.variant.textContent = variant?.title || '';
          } catch { this.variant.hidden = true; }
        }
        const wrapper = this.main?.querySelector('.product-form__error-message-wrapper');
        const error = wrapper && !wrapper.hidden ? wrapper.querySelector('.product-form__error-message')?.textContent.trim() : '';
        this.error.hidden = !error;
        if (this.error.textContent !== (error || '')) this.error.textContent = error || '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-reviews-page"] && !Shopify.designMode) return;
  try {
    
function initAstraReviews(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const cards=Array.from(root.querySelectorAll('[data-review-card]'));if(!cards.length)return;const filter=root.querySelector('[data-reviews-filter]'),more=root.querySelector('[data-reviews-more]'),status=root.querySelector('[data-reviews-status]'),empty=root.querySelector('[data-reviews-empty]');let shown=6;function update(){const matching=cards.filter(card=>filter.value==='all'||card.dataset.rating===filter.value);cards.forEach(card=>card.hidden=true);matching.slice(0,shown).forEach(card=>card.hidden=false);more.hidden=shown>=matching.length;empty.hidden=matching.length!==0;status.textContent=root.dataset.statusTemplate.replace('[visible]',Math.min(shown,matching.length)).replace('[total]',matching.length)}filter.closest('.ub-reviews__filter').hidden=false;root.querySelector('.ub-reviews__pagination').hidden=false;filter.addEventListener('change',()=>{shown=6;update()});more.addEventListener('click',()=>{shown+=6;update()});update()}
document.querySelectorAll('[data-reviews-page]').forEach(initAstraReviews);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-reviews-page]').forEach(initAstraReviews));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  function initializeAtlasSearch(root) {
    const page = root.querySelector('.atlas-faq-page');
    const input = page?.querySelector('#nativeSearch');
    if (!input || input.dataset.searchReady) return;
    input.dataset.searchReady = 'true';
    const items = Array.from(page.querySelectorAll('.atlas-details'));
    const initialOpen = new Map(items.map(item => [item, item.open]));
    const sections = Array.from(page.querySelectorAll('.atlas-section'));
    const empty = page.querySelector('#atlasNoResult');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    const update = () => {
      const term = normalize(input.value);
      let matches = 0;
      items.forEach(item => {
        const match = !term || normalize(item.textContent).includes(term);
        item.hidden = !match;
        item.open = term ? match : initialOpen.get(item);
        if (match) matches += 1;
      });
      sections.forEach(section => {
        section.hidden = !Array.from(section.querySelectorAll('.atlas-details')).some(item => !item.hidden);
      });
      if (empty) empty.hidden = matches > 0;
    };
    if (empty) { empty.setAttribute('role', 'status'); empty.setAttribute('aria-live', 'polite'); }
    input.addEventListener('input', update);
    update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAtlasSearch(document), { once: true });
  } else {
    initializeAtlasSearch(document);
  }
  document.addEventListener('shopify:section:load', event => initializeAtlasSearch(event.target));

  } catch(e) { console.error(e); }
})();
})();
